import { useNavigateTo } from './useNavigateTo';
import { ROUTES } from '../../constants';
import { useCallback, useState } from 'react';
import { useInitialize } from './useInitialize';
import { removeExactDuplicates } from '../utils';

const localStorageKey = 'pastSearches';

export function useSearch() {
    const [pastSearches, setPastSearches] = useState<string[]>([]);
    const navigateTo = useNavigateTo();

    const getPastSearches = useCallback(() => {
        const storedValue = JSON.parse(localStorage.getItem(localStorageKey) ?? '[]');
        setPastSearches(storedValue);
    }, []);

    useInitialize(getPastSearches);

    const updatePastSearches = useCallback((newValue: string) => {
        setPastSearches((prev) => {
            const newList = removeExactDuplicates([...prev, newValue]);

            if (newList.length > 4) newList.shift();
            localStorage.setItem(localStorageKey, JSON.stringify(newList));
            return newList;
        });
    }, []);

    const onSearch = useCallback(
        (searchTerm: string) => {
            updatePastSearches(searchTerm);
            navigateTo(ROUTES.SearchResults, `?term=${searchTerm}`);
        },
        [updatePastSearches, navigateTo]
    );

    const removePastSearch = useCallback(
        (searchTerm: string) => {
            const newList = pastSearches.filter((item) => item !== searchTerm);
            localStorage.setItem(localStorageKey, JSON.stringify(newList));
            setPastSearches(newList);
        },
        [pastSearches]
    );

    return {
        pastSearches,
        onSearch,
        removePastSearch,
        updatePastSearches,
        refreshPastSearches: getPastSearches
    };
}
